import { useState, useCallback } from 'react';

export const useSelection = (initialSelection = []) => {
  const [selectedNodeIds, setSelectedNodeIds] = useState(initialSelection);

  const selectNode = useCallback((nodeId, options = {}) => {
    const { multi = false, toggle = false } = options;

    setSelectedNodeIds(prev => {
      if (toggle) {
        return prev.includes(nodeId)
          ? prev.filter(id => id !== nodeId)
          : [...prev, nodeId];
      }

      if (multi) {
        return prev.includes(nodeId) ? prev : [...prev, nodeId];
      }

      return [nodeId];
    });
  }, []);

  const selectNodes = useCallback((nodeIds, options = {}) => {
    const { append = false } = options;
    setSelectedNodeIds(prev => append ? [...new Set([...prev, ...nodeIds])] : nodeIds);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedNodeIds([]);
  }, []);

  const isSelected = useCallback((nodeId) => {
    return selectedNodeIds.includes(nodeId);
  }, [selectedNodeIds]);

  const toggleSelection = useCallback((nodeId) => {
    setSelectedNodeIds(prev =>
      prev.includes(nodeId)
        ? prev.filter(id => id !== nodeId)
        : [...prev, nodeId]
    );
  }, []);

  return {
    selectedNodeIds,
    setSelectedNodeIds,
    selectNode,
    selectNodes,
    clearSelection,
    isSelected,
    toggleSelection
  };
};
